import { cn as e } from "../cn.js";
import { Loading as t } from "../loading/index.js";
import { getStyles as n } from "./style.js";
import "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
// src/design/stat-group/index.tsx
var a = ({ columns: a = 4, loading: o = !1, loadingCount: s, className: c, children: l, ...u }) => {
	let d = n();
	return /* @__PURE__ */ r("div", {
		role: u["aria-label"] || u["aria-labelledby"] ? "group" : void 0,
		className: e(d.root({ columns: a }), c),
		"aria-busy": o || void 0,
		...u,
		children: o ? Array.from({ length: s ?? a }, (e, n) => /* @__PURE__ */ i("div", {
			"aria-hidden": "true",
			className: d.item(),
			children: [/* @__PURE__ */ r(t.Skeleton, {
				variant: "text",
				className: "h-3 w-2/3"
			}), /* @__PURE__ */ r(t.Skeleton, {
				variant: "rounded",
				className: "mt-2 h-7 w-1/2"
			})]
		}, n)) : l
	});
};
function o({ as: t, label: a, value: o, detail: s, tone: c = "default", interactive: l, className: u, ...d }) {
	let f = n(), p = t ?? "div", m = l ?? (t !== void 0 && t !== "div");
	return /* @__PURE__ */ i(p, {
		className: e(f.item({ interactive: m }), u),
		...d,
		children: [
			/* @__PURE__ */ r("span", {
				className: f.label(),
				children: a
			}),
			/* @__PURE__ */ r("span", {
				className: f.value({ tone: c }),
				children: o
			}),
			s != null && s !== "" ? /* @__PURE__ */ r("span", {
				className: f.detail(),
				children: s
			}) : null
		]
	});
}
var s = Object.assign(({ items: e, ...t }) => /* @__PURE__ */ r(a, {
	...t,
	children: e.map((e, t) => /* @__PURE__ */ r(o, {
		label: e.label,
		value: e.value,
		detail: e.detail,
		tone: e.tone
	}, e.id ?? (typeof e.label == "string" ? e.label : t)))
}), {
	Root: a,
	Item: o
});
export { s as StatGroup };

//# sourceMappingURL=index.js.map